const initialState = {
  required: true,
  options: { phoneNumbers: [], emailAddresses: [], mfaMemberId: null },
};

export const mfa = (state = initialState, action) => {
  switch (action.type) {
    case "MFA_SET_REQUIRED":
      return {
        ...state,
        required: action.required,
      };
    case "MFA_SET_OPTIONS":
      return {
        ...state,
        options: action.options,
      };
    case "CLEAR_MFA":
      return initialState;
    case "MFA_REACHED_MAX":
      return{
        ...state,
        hasReachedMax: true,
      };    
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mfa.js